<div class="input-group__prefix">
  <ng-content select="[input-prefix]"></ng-content>
</div>
<div class="input-group__infix">
  <ng-content></ng-content>
</div>
<div class="input-group__suffix">
  <ng-content select="[input-suffix]"></ng-content>
</div>
